import React, { useState } from 'react';
import { PDFViewer, StyleSheet } from '@react-pdf/renderer';
import TransactionDetailPDF from './TransactionDetailPDF';

const styles = StyleSheet.create({
  body: {
    width: '100%',
    height: '800px',
  },
});
function PreviewPDF() {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const jsonArray = urlParams.get('data');
  const parsedArray = JSON.parse(jsonArray);
  

  return (
    <PDFViewer style={styles.body}>
      <div>PreviewPDF</div>
      <TransactionDetailPDF parsedArray={parsedArray} />
    </PDFViewer>
  );
}

export default PreviewPDF;
